require([
	'jquery',
	'base/MbiMediaQuery'
], function($,mbiMq) {
	'use strict';


});
define("root/Assets/Templates/Content/ProjectsNav/Js/ProjectsNav", function(){});

